import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './context/AuthContext';
import { ModalProvider } from './context/ModalContext';
import App from './App.jsx';
import './index.css';

// Импортируем Buffer и делаем его глобальным для TON SDK
import { Buffer } from 'buffer';
window.Buffer = Buffer;

const preloader = document.getElementById('preloader');
if (preloader) {
  preloader.remove();
}
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(() => console.log('✅ SW registered'))
      .catch(err => console.error('❌ SW error', err));
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
   <AuthProvider>
      <ModalProvider>
        <App />
      </ModalProvider>
    </AuthProvider>	
  </React.StrictMode>
);